<template>
    <div class="highschool-analysis-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <!-- 筛选区 -->
            <div class="search-box">
                <el-select v-model="filterForm.province" multiple placeholder="全部省份" style="width: 200px;" clearable>
                    <el-option v-for="item in provinceOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="filterForm.kl" multiple placeholder="全部科类" style="width: 200px;" clearable>
                    <el-option v-for="item in klOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="filterForm.pc" multiple placeholder="全部批次" style="width: 200px;" clearable>
                    <el-option v-for="item in pcOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-button type="primary" @click="loadData" :loading="loading">查询</el-button>
                <el-button @click="resetFilter">重置</el-button>
            </div>

            <!-- 分析文字 -->
            <div class="section-block">
                <p v-if="analysisText" v-html="analysisText"></p>
            </div>

            <!-- 直方图 -->
            <div class="section-block">
                <div class="chart-wrapper">
                    <div class="chart-controls-right">
                        <el-button size="mini" icon="el-icon-download" @click="downloadBar">下载图片</el-button>
                    </div>
                    <v-chart ref="barChart" :option="barOption" style="height: 350px;" autoresize></v-chart>
                </div>
            </div>

            <!-- 详情表格 -->
            <div class="section-block">
                <div class="section-header">
                    <h3 class="section-title">生源高中详情</h3>
                    <el-button type="success" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
                </div>
                <div class="data-table-wrapper">
                    <div class="data-table-body">
                        <el-table :data="tableData" border :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}">
                            <el-table-column type="index" label="序号" min-width="60" align="center"></el-table-column>
                            <el-table-column prop="Province" label="省" min-width="100" align="center"></el-table-column>
                            <el-table-column prop="City" label="市" min-width="120" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.City || '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="County" label="区/县" min-width="120" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.County || '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="SchoolName" label="中学名称" align="center"></el-table-column>
                            <el-table-column prop="TotalCount" label="录取人数" min-width="100" align="center"></el-table-column>
                            <el-table-column prop="Ratio" label="比例" min-width="100" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.Ratio ? scope.row.Ratio.toFixed(2) + '%' : '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="详情" min-width="100" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="showDetail(scope.row)">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>

        <!-- 高中详情弹窗 -->
        <el-dialog :title="currentSchool.SchoolName + ' - 招生详情'" :visible.sync="detailDialogVisible" width="90%" top="5vh">
            <div class="school-detail-container">
                <div style="margin-bottom: 15px;">
                    <p v-if="detailAnalysisText" v-html="detailAnalysisText"></p>
                </div>
                <div class="chart-wrapper" style="margin-bottom: 15px;">
                    <div class="chart-controls-right">
                        <el-button size="mini" icon="el-icon-download" @click="downloadDetailBar">下载图片</el-button>
                    </div>
                    <v-chart ref="detailBarChart" :option="detailBarOption" style="height: 350px;" autoresize></v-chart>
                </div>
                <div class="section-header">
                    <h3></h3>
                    <el-button type="success" size="small" icon="el-icon-download" @click="handleExportDetail">导出</el-button>
                </div>
                <el-table :data="detailTableData" border style="width: 100%" :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}" max-height="400px">
                    <el-table-column type="index" label="序号" min-width="60" align="center"></el-table-column>
                    <el-table-column prop="Kl" label="科类" min-width="100" align="center"></el-table-column>
                    <el-table-column prop="Pc" label="批次" min-width="150" align="center"></el-table-column>
                    <el-table-column prop="MajorName" label="专业" min-width="200" align="center"></el-table-column>
                    <el-table-column prop="MaxScore" label="最高分" min-width="100" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.MaxScore ? scope.row.MaxScore.toFixed(1) : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="MinScore" label="最低分" min-width="100" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.MinScore ? scope.row.MinScore.toFixed(1) : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="AvgScore" label="平均分" min-width="100" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.AvgScore ? scope.row.AvgScore.toFixed(1) : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="TotalCount" label="录取数" min-width="100" align="center"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';
import VChart from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';

export default {
    name: 'HighSchoolAnalysis',
    components: {
        VChart
    },
    inject: ['Loading', 'LoadingCompleted'],
    data() {
        return {
            Status: {
                LoadingCompleted: false
            },
            loading: false,
            filterForm: {
                province: [],
                kl: [],
                pc: []
            },
            provinceOptions: [],
            klOptions: [],
            pcOptions: [],
            tableData: [],
            analysisText: '',
            schoolName: '',
            year: 0,
            totalCount: 0,
            barOption: {},
            detailDialogVisible: false,
            currentSchool: {},
            detailTableData: [],
            detailAnalysisText: '',
            detailBarOption: {}
        };
    },
    methods: {
        loadFilters() {
            const that = this;
            const api_name = '/Analysis/GetHighSchoolFilters';
            const url = TYBM_Env.GetApiUrl(api_name);

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading: false })
                .then(result => {
                    that.provinceOptions = result.data.ProvinceOptions || [];
                    that.klOptions = result.data.KlOptions;
                    that.pcOptions = result.data.PcOptions;
                });
        },
        loadData() {
            const that = this;
            that.loading = true;

            const api_name = '/Analysis/GetHighSchoolData';
            let url = TYBM_Env.GetApiUrl(api_name);

            const params = [];
            if (that.filterForm.province && that.filterForm.province.length > 0) {
                params.push('Province=' + encodeURIComponent(that.filterForm.province.join(',')));
            }
            if (that.filterForm.kl && that.filterForm.kl.length > 0) {
                params.push('Kl=' + encodeURIComponent(that.filterForm.kl.join(',')));
            }
            if (that.filterForm.pc && that.filterForm.pc.length > 0) {
                params.push('PC=' + encodeURIComponent(that.filterForm.pc.join(',')));
            }
            if (params.length > 0) {
                url += '?' + params.join('&');
            }

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' })
                .then(result => {
                    that.tableData = result.data.StatList;
                    that.totalCount = result.data.TotalCount;
                    that.schoolName = result.data.SchoolName;
                    that.year = result.data.Year;

                    if (that.klOptions.length === 0) {
                        that.loadFilters();
                    }

                    that.generateAnalysisText();
                    that.generateBarChart();
                    that.Status.LoadingCompleted = true;
                })
                .catch(() => {
                    that.$message.error('加载数据失败');
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        resetFilter() {
            this.filterForm.province = [];
            this.filterForm.kl = [];
            this.filterForm.pc = [];
            this.loadData();
        },
        generateAnalysisText() {
            const that = this;
            if (!that.tableData || that.tableData.length === 0) {
                that.analysisText = '';
                return;
            }

            const top10 = that.tableData.slice(0, Math.min(10, that.tableData.length));
            const top10Names = top10.map(item => item.SchoolName).join('、');

            that.analysisText = `全国招生${that.totalCount}人，其中招生人数最多的${top10.length}个高中是${top10Names}。`;
        },
        generateBarChart() {
            const that = this;
            const top10 = that.tableData.slice(0, Math.min(10, that.tableData.length));
            const names = top10.map(item => item.SchoolName);
            const counts = top10.map(item => item.TotalCount);

            that.barOption = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value'
                },
                yAxis: {
                    type: 'category',
                    data: names,
                    inverse: true
                },
                series: [
                    {
                        type: 'bar',
                        data: counts,
                        barMaxHeight: 40,
                        itemStyle: {
                            color: '#409EFF'
                        },
                        label: {
                            show: true,
                            position: 'right',
                            fontSize: 12
                        }
                    }
                ]
            };
        },
        downloadBar() {
            const chart = this.$refs.barChart;
            if (chart) {
                const url = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff'
                });
                const link = document.createElement('a');
                link.download = `生源高中录取人数_${this.year}.png`;
                link.href = url;
                link.click();
            }
        },
        showDetail(row) {
            const that = this;
            that.currentSchool = row;
            that.detailDialogVisible = true;

            const api_name = '/Analysis/GetHighSchoolDetail';
            let url = TYBM_Env.GetApiUrl(api_name);
            url += '?SchoolCode=' + encodeURIComponent(row.SchoolCode);

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载详情' })
                .then(result => {
                    that.detailTableData = result.data.DetailList;
                    
                    // 生成详情分析文字
                    const top10 = that.detailTableData.slice(0, Math.min(10, that.detailTableData.length));
                    const top10Text = top10.map(item => {
                        const ratio = (item.TotalCount / row.TotalCount * 100).toFixed(0);
                        return `${item.MajorName}${item.TotalCount}人(${ratio}%)`;
                    }).join('、');
                    that.detailAnalysisText = `${row.SchoolName}共招生${row.TotalCount}人，招生人数前${top10.length}的专业为${top10Text}。`;
                    
                    // 生成详情图表
                    const detailNames = that.detailTableData.map(item => item.MajorName);
                    const detailCounts = that.detailTableData.map(item => item.TotalCount);
                    
                    that.detailBarOption = {
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '15%',
                            top: '5%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: detailNames,
                            axisLabel: {
                                interval: 0,
                                rotate: 0,
                                fontSize: 12
                            }
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                            {
                                type: 'bar',
                                data: detailCounts,
                                barMaxWidth: 40,
                                itemStyle: {
                                    color: '#67C23A'
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                    fontSize: 10
                                }
                            }
                        ]
                    };
                })
                .catch(() => {
                    that.$message.error('加载详情失败');
                });
        },
        downloadDetailBar() {
            const chart = this.$refs.detailBarChart;
            if (chart) {
                const url = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff'
                });
                const link = document.createElement('a');
                link.download = `${this.currentSchool.SchoolName}_专业分布_${this.year}.png`;
                link.href = url;
                link.click();
            }
        },
        handleExport() {
            const that = this;
            if (that.tableData.length === 0) {
                that.$message.warning('没有数据可导出');
                return;
            }

            let csvContent = "\uFEFF";
            const headers = ["序号", "省", "市", "区/县", "中学名称", "录取人数", "比例"];
            csvContent += headers.join(",") + "\n";

            that.tableData.forEach((row, index) => {
                const rowData = [
                    index + 1,
                    row.Province,
                    row.City,
                    row.County,
                    row.SchoolName,
                    row.TotalCount,
                    row.Ratio ? row.Ratio.toFixed(2) + '%' : '-'
                ];
                csvContent += rowData.join(",") + "\n";
            });

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `生源高中详情_${that.year}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        handleExportDetail() {
            const that = this;
            if (that.detailTableData.length === 0) {
                that.$message.warning('没有数据可导出');
                return;
            }

            let csvContent = "\uFEFF";
            const headers = ["序号", "科类", "批次", "专业", "最高分", "最低分", "平均分", "录取数"];
            csvContent += headers.join(",") + "\n";

            that.detailTableData.forEach((row, index) => {
                const rowData = [
                    index + 1,
                    row.Kl,
                    row.Pc,
                    row.MajorName,
                    row.MaxScore ? row.MaxScore.toFixed(1) : '-',
                    row.MinScore ? row.MinScore.toFixed(1) : '-',
                    row.AvgScore ? row.AvgScore.toFixed(1) : '-',
                    row.TotalCount
                ];
                csvContent += rowData.join(",") + "\n";
            });

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `${that.currentSchool.SchoolName}_招生详情_${that.year}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
    created() {
        this.loadData();
    },
    mounted() {
        this.$root.$on('global-year-change', this.loadData);
    },
    beforeDestroy() {
        this.$root.$off('global-year-change', this.loadData);
    }
};
</script>

<style scoped>
.highschool-analysis-container {
    width: 100%;
}

.search-box {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    align-items: center;
}

.section-block {
    margin-bottom: 0px;
    background: white;
    border-radius: 8px;
    padding: 5px;
}

.section-title {
    margin: 0 0 12px 0;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.chart-wrapper {
    position: relative;
    margin-top: 40px;
}

.chart-controls-right {
    position: absolute;
    right: 10px;
    top: -30px;
    z-index: 10;
    display: flex;
    gap: 10px;
    align-items: center;
}

.data-table-wrapper {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: auto;
    max-height: calc(100vh - 520px);
}

.data-table-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.data-table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.data-table-body {
    width: max-content;
    min-width: 100%;
}

.data-table-body >>> .el-table {
    font-size: 13px;
    width: 100%;
}

.data-table-body >>> .el-table th,
.data-table-body >>> .el-table td {
    padding: 8px 0 !important;
}

.data-table-body >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.data-table >>> .el-table .cell {
    padding: 0 8px;
}

.school-detail-container {
    margin-top: -15px;
}
</style>

